import React from 'react';
import { Grid, Typography } from '@mui/material';
import { UploadCard } from '../atoms';

export const Connect = (): JSX.Element => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="left"
      columnSpacing={4}
      sx={{
        px: { xs: 2, md: 10 },
        marginTop: { xs: 10 },
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h4"> Upload Data </Typography>
      </Grid>
      <Grid item xs={12} sx={{ paddingBottom: 7 }}>
        <Typography variant="light">
          We can analyze third-party health data to tailor your precision
          multivitamin to your specific needs.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <UploadCard
          cardTitle="DNA"
          title={'Upload select 3rd party providers'}
          body={`Use DNA data to create a unique nutrient profile based 
                  on gene variants research-proven to affect micronutrients needs.`}
          buttonLabel={'Submit DNA data'}
          buttonLink="https://app.rhodiumsoftware.com/dashboard/dna/upload"
          buttonFill={true}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UploadCard
          cardTitle="BLOOD"
          title="Upload select 3rd party Blood data"
          body={`Use blood data to create a unique nutrient profile based 
                  on current blood nutrient levels.`}
          buttonLabel="Submit blood data"
          buttonLink="/dashboard/blood-upload"
          buttonFill={true}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4"> Connect Data </Typography>
      </Grid>
      <Grid item xs={12} sx={{ paddingBottom: 7 }}>
        <Typography variant="light">
          We can integrate your wearable device data to further tailor your
          precision multivitamin formula.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <UploadCard
          cardTitle="WEARABLES"
          title="Connect your wearable devices."
          body={`Integrate your wearable to improve nutrient recommendations`}
          buttonLabel="Coming Soon"
          buttonFill={false}
        />
      </Grid>
    </Grid>
  );
};
